import React from "react";
import styles from "./Comments.module.css";

import CommentSingle from "./Single";

const Comments = props => {
  const { messages, ...other } = props;
  let messagesDOM = [];

  messages.length > 0 &&
    messages.forEach((msg, index) =>
      messagesDOM.push(
        <CommentSingle index={index} username={msg.user.username} message={msg.message} created_at={msg.created_at} />,
      ),
    );

  return (
    <div {...other}>
      <ul className={styles.containerMsg}>{messagesDOM}</ul>
    </div>
  );
};

export default Comments;
